var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHatMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 50,
    viewBox: "0 0 82 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_236_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 0.655029L40.2602 0.879233L10.717 10.7631L4 12.9745L9 14.655V35.3054C6.5 36.7188 7 41.7188 10.5 41.7188C14 41.7188 15 37.2188 12 35.3054V15.8537L17.3654 17.3995V29.4948C17.3654 31.43 18.5471 33.0348 19.951 34.1441C21.3549 35.2462 23.0991 36.025 25.1932 36.7236C29.3859 38.116 34.9117 38.9349 41 38.9349C47.0883 38.9349 52.6141 38.1184 56.8068 36.7212C58.9009 36.025 60.6451 35.2462 62.049 34.1417C63.4529 33.0348 64.6346 31.43 64.6346 29.4948V17.3995L71.283 15.1858L78 12.9745L71.2807 10.7607L41.7374 0.879233L41 0.655029ZM40.9772 4.15503L66.4543 13.0302L40.9772 21.8496L15.5 12.9745L40.9772 4.15503ZM22.0923 19.0233L40.2626 25.0697L41 25.2915L41.7398 25.0673L61 18.6812V29.155C61 29.1786 60.2492 30.5674 59.5 31.155C58.7531 31.745 57.081 32.374 55.3273 32.9593C51.8247 34.1228 46.6605 35.5388 41 35.5388C35.3395 35.5388 30.1753 34.1275 26.6703 32.9593C24.9214 32.3764 23.2469 31.7427 22.5 31.155C21.7484 30.565 21 29.1786 21 29.155V18.6812L22.0923 19.0233Z",
    fill: "#3C789E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_236_14",
    x: 0,
    y: 0.655029,
    width: 82,
    height: 49.0637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_14",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatMain);
export default __webpack_public_path__ + "static/media/hatMain.1a4c271c07eb968df7207794c1735f8b.svg";
export { ForwardRef as ReactComponent };